// KYC types
export const TYPE_IDENTITY = 'identity';
export const TYPE_ADDRESS = 'address';
export const TYPE_SELFIE = 'selfie';

// OLD KYC TYPES
export const TYPE_IDENTITY_OLD = ['passport', 'id_card', 'driving_license'];
export const TYPE_ADDRESS_OLD = 'proof_of_address';

// KYC subtypes
export const SUBTYPE_PASSPORT = 'passport';
export const SUBTYPE_ID_CARD = 'idCard';
export const SUBTYPE_DRIVER_LIC = 'drivingLicense';
export const SUBTYPE_BANK_STATEMENT = 'bankStatement';
export const SUBTYPE_FIXED_SERVICES_BILL = 'fixedServicesBill';
export const SUBTYPE_INTERNET_OR_TV_BILL = 'internetOrTvBill';
export const SUBTYPE_WATER_BILL = 'waterBill';
export const SUBTYPE_ELECTRICITY_BILL = 'electricityBill';
export const SUBTYPE_GAS_BILL = 'gasBill';
export const SUBTYPE_SELFIE = 'selfie';
export const SUBTYPE_SELFIE_WITH_ID = 'selfieWithId';
